import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import { classnames } from '@@client/lib/classes';
export default function SlideOpen(_ref) {
  var id = _ref.id,
      title = _ref.title,
      children = _ref.children,
      _ref$doTriggerToggle = _ref.doTriggerToggle,
      doTriggerToggle = _ref$doTriggerToggle === void 0 ? function () {} : _ref$doTriggerToggle,
      _ref$doTriggerClose = _ref.doTriggerClose,
      doTriggerClose = _ref$doTriggerClose === void 0 ? function () {} : _ref$doTriggerClose;

  var _useState = useState(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var toggleIsOpen = function toggleIsOpen() {
    return isOpen ? setIsOpen(false) : setIsOpen(true);
  };

  doTriggerToggle(toggleIsOpen);
  doTriggerClose(function () {
    return setIsOpen(false);
  });
  var classNames = classnames(['slide-open', isOpen ? 'is-open' : 'not-open']);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "jsx-2163727271" + " " + (classNames || ""),
      children: [title ? /*#__PURE__*/_jsx("button", {
        "aria-haspopup": "true",
        "aria-expanded": isOpen ? 'true' : 'false',
        "aria-controls": id,
        onClick: toggleIsOpen,
        className: "jsx-2163727271" + " " + 'action-open m--no-btn',
        children: title
      }) : null, /*#__PURE__*/_jsx(CSSTransition, {
        classNames: "dropdown-transition",
        "in": isOpen,
        timeout: 300,
        appear: true,
        onEnter: function onEnter(el) {
          el.style.height = el.scrollHeight + 'px';
        },
        onEntered: function onEntered(el) {
          el.style.height = 'auto';
        },
        onExit: function onExit(el) {
          el.style.height = el.scrollHeight + 'px';
        },
        onExiting: function onExiting(el) {
          el.style.height = 0;
        },
        onExited: function onExited(el) {
          el.style.height = null;
        },
        children: /*#__PURE__*/_jsx("div", {
          id: id,
          className: "jsx-2163727271" + " " + 'dropdown',
          children: children
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "2163727271",
      children: [".slide-open.jsx-2163727271{border-top:1px solid #9BA3C3;border-bottom:0 solid #9BA3C3;}", "button.jsx-2163727271{width:100%;padding:13px 10px;color:white;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:justify;-ms-flex-pack:justify;-webkit-box-pack:justify;-webkit-justify-content:space-between;-ms-flex-pack:justify;justify-content:space-between;cursor:pointer;}", "button.jsx-2163727271::after{content:'';display:block;width:10px;height:10px;border-top:3px solid white;border-right:3px solid white;-webkit-transform:rotate(45deg);-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);-webkit-transition:all 300ms ease;-webkit-transition:all 300ms ease;transition:all 300ms ease;}", ".is-open.jsx-2163727271 button.jsx-2163727271::after{-webkit-transform:rotate(135deg);-webkit-transform:rotate(135deg);-ms-transform:rotate(135deg);transform:rotate(135deg);}", ".dropdown.jsx-2163727271{display:none;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:0;-webkit-transition:all 300ms ease;-webkit-transition:all 300ms ease;transition:all 300ms ease;}", ".dropdown.jsx-2163727271>ul{list-style:none;margin:0;padding:0;}", ".dropdown.jsx-2163727271 button.m--as-link,.dropdown.jsx-2163727271 a{display:block;color:white;padding:10px 0;-webkit-text-decoration:none;text-decoration:none;}", ".dropdown-transition-enter.jsx-2163727271,.dropdown-transition-enter-done.jsx-2163727271,.dropdown-transition-exit.jsx-2163727271{display:block;}"]
    })]
  });
}